<template>
    <el-tooltip placement="top" :content="localizedEnum" :open-delay="300">
        <i class="fa font_lg secondary_color enum_icon" :class="icon" aria-hidden="true"></i>
    </el-tooltip>
</template>

<script>
import {formatAsLocalizedEnum} from "@/common/format";

export default {
	data() {
		return {
			localizedEnum: "",
			icon: ""
        }
    },
    beforeMount() {
        let enumDef = this.params.colDef.enumDef;
        let value = this.params.value;

        this.localizedEnum = formatAsLocalizedEnum(enumDef, value);

        if (enumDef.hasOwnProperty("properties") && enumDef.properties.hasOwnProperty(value)) {
            this.icon = enumDef.properties[value].icon;
        } else {
            this.icon = "fa-question";
        }

    }
};
</script>

<style lang="scss" scoped>
.enum_icon {
    line-height: 26px;
}
</style>
